import React from "react";

import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import Dialog from "ds/Dialog";
import Tag from "ds/Tag";

import { Header } from "../Header";
import * as Specificities from "../Specificities";
import Validation from "../Validation";

import StickerBlackfire from "./Blackfire/StickerBlackfire";
import * as S from "./Details.styles";

import type { Integration } from "@packages/client";

type DetailsProps = {
  integration: Integration;
};

const Details = ({ integration }: DetailsProps) => {
  const intl = useIntl();
  const category = integration.category;
  const isBlackfireCategory = category === "blackfire";

  const getSpecificities = () => {
    if (!category) return null;
    const k = (category.charAt(0).toUpperCase() +
      category.slice(1)) as keyof typeof Specificities;
    const Comp = Specificities[k];
    if (!Comp) return null;
    return <Comp integration={integration} />;
  };

  const validateCmd = `${intl.formatMessage({
    id: "CLI_command_name"
  })} integration:validate ${integration.id}`;

  return (
    <>
      {isBlackfireCategory && <StickerBlackfire />}

      <section>
        <Header integration={integration} />
      </section>

      <S.Wrapper>
        <S.Header>
          <S.Title tag="h2" isBlackfireCategory={isBlackfireCategory}>
            {intl.formatMessage({
              id: "integration.title",
              defaultMessage: "Details"
            })}
          </S.Title>
          {isBlackfireCategory && (
            <Dialog
              analyticId="integration.blackfire.info.description"
              title={intl.formatMessage({
                id: "integration.blackfire.info.title",
                defaultMessage: "Integrations settings"
              })}
              description={intl.formatMessage({
                id: "integration.blackfire.info.description",
                defaultMessage:
                  "You can customize your integrations through our Command Line Interface (CLI)."
              })}
              link={
                <Link
                  href={intl.formatMessage({
                    id: "links.observability-suite-blackfire.integrate"
                  })}
                  analyticId="learnmore"
                >
                  {intl.formatMessage({ id: "learnmore" })}
                </Link>
              }
            />
          )}

          {category && (
            <Tag variant="gray">
              {" "}
              {intl.formatMessage({
                id: `integrations.category.${category}`,
                defaultMessage: category
              })}
            </Tag>
          )}
        </S.Header>

        {integration._links?.["#validate"] && (
          <Validation validateCmd={validateCmd} />
        )}
        {getSpecificities()}
      </S.Wrapper>
    </>
  );
};

export default Details;
